export class PriorityDto {
    id?: number;
    level!: number;
    name!: string;
    cssClassName?: string;
}